import Vue from 'vue'; // 引入vue文件
import App from './App'; // 引入项目
import router from './router'; // 引入路由文件

import './common/css/base.css'; // 引入初始化css

import 'lib-flexible'; // 引入自适应文件

import store from './store/index'; // 引入vuex

import dataV from '@jiaminghi/data-view' // 引入大数据框架

import {
	Carousel,
	CarouselItem,
	Image
} from 'element-ui'; // 引入elementUI的轮播图组件

import 'element-ui/lib/theme-chalk/index.css';

import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts

Vue.use(dataV)
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Image);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js